export const COURSE_INFORMATION_ID = "lazyblock/course-information";
export const REGISTRATION_REQUIREMENTS_ID =
  "lazyblock/registration-requirements";
export const PAYMENTS_DISCOUNTS = "lazyblock/payments-discounts";
